module.exports = __webpack_public_path__ + "img/h-logo2-icon-index.210f2fe5.png";